import SiteUnavailableState from "./SiteUnavailableState";

const NoPublishedContentState = () => {
  return (
    <SiteUnavailableState
      reason="offline"
      customMessage="This site hasn't been published yet."
    />
  );
};

export default NoPublishedContentState;